import { useState, useEffect, useCallback } from 'react';
import '../pages/DashboardPage.css';

function AdminLoansPage() {
    const [pendingLoans, setPendingLoans] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [actionLoading, setActionLoading] = useState(null);

    const API_URL = process.env.REACT_APP_API_URL || '';

    const fetchPendingLoans = useCallback(() => {
        setIsLoading(true);
        console.log('🛡️ [FRONTEND-ADMIN] Fetching pending loans...');
        const fetchUrl = `${API_URL}/api/admin/loans/pending`;
        console.log(`🌐 [FRONTEND-ADMIN] URL: ${fetchUrl}`);

        fetch(fetchUrl)
            .then(res => {
                console.log(`📡 [FRONTEND-ADMIN] Fetch Loans status: ${res.status}`);
                return res.json();
            })
            .then(data => {
                console.log('📦 [FRONTEND-ADMIN] Fetch Loans data:', data);
                if (data.success) {
                    setPendingLoans(data.loans);
                }
            })
            .catch(err => console.error('❌ [FRONTEND-ADMIN] Fetch error:', err))
            .finally(() => setIsLoading(false));
    }, [API_URL]);

    useEffect(() => {
        fetchPendingLoans();
    }, [fetchPendingLoans]);

    const handleUpdateStatus = async (loanId, status) => {
        console.log(`🛠️ [FRONTEND-ADMIN] Updating Loan ID ${loanId} to status: ${status}`);
        if (!window.confirm(`Are you sure you want to ${status === 'Active' ? 'APPROVE' : 'REJECT'} this loan application?`)) {
            console.log('🚫 [FRONTEND-ADMIN] Update cancelled by user');
            return;
        }

        const session = JSON.parse(localStorage.getItem('userSession'));
        setActionLoading(loanId);

        try {
            const fetchUrl = `${API_URL}/api/admin/loans/update-status`;
            console.log(`🌐 [FRONTEND-ADMIN] POSTing to: ${fetchUrl}`);
            const response = await fetch(fetchUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    loanId,
                    status,
                    adminId: session.userId
                })
            });

            console.log(`📡 [FRONTEND-ADMIN] Update status response: ${response.status}`);
            const data = await response.json();
            console.log('📦 [FRONTEND-ADMIN] Update status data:', data);

            if (data.success) {
                console.log('✅ [FRONTEND-ADMIN] Update successful! Refreshing list...');
                alert(`Loan application ${status === 'Active' ? 'approved' : 'rejected'} successfully!`);
                fetchPendingLoans();
            } else {
                console.warn('⚠️ [FRONTEND-ADMIN] Update failure:', data.message);
                alert(data.message || 'Failed to update status.');
            }
        } catch (err) {
            console.error('❌ [FRONTEND-ADMIN] Update error:', err);
            alert('An error occurred. Please try again.');
        } finally {
            setActionLoading(null);
        }
    };

    return (
        <div className="dashboard-page-new">
            {/* Page Header */}
            <div className="welcome-section">
                <div>
                    <h1>Loan Approvals 🛡️</h1>
                    <p className="welcome-subtitle">Review and manage pending loan applications</p>
                </div>
            </div>

            {/* Pending Loans Section */}
            <div className="content-section loans-section-new">
                <div className="section-header-new">
                    <h2>Pending Applications</h2>
                    <span className="loan-count">{pendingLoans.length} applications waiting</span>
                </div>

                {isLoading ? (
                    <div style={{ textAlign: 'center', padding: '3rem' }}>
                        <p>Loading pending applications...</p>
                    </div>
                ) : pendingLoans.length > 0 ? (
                    <div className="loans-grid">
                        {pendingLoans.map((loan) => (
                            <div key={loan.id} className="loan-card-new admin-view">
                                <div className="loan-card-header">
                                    <div>
                                        <h3 style={{ color: '#fcc201', marginBottom: '0.25rem' }}>{loan.type}</h3>
                                        <span className="account-number">Ref: {loan.account_number}</span>
                                    </div>
                                    <span className="status-badge pending">PENDING</span>
                                </div>

                                <div className="user-details-mini" style={{ margin: '1rem 0', padding: '1rem', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                        <span style={{ fontSize: '1.2rem' }}>👤</span>
                                        <strong>{loan.first_name} {loan.last_name}</strong>
                                    </div>
                                    <div style={{ fontSize: '0.9rem', color: '#888', marginLeft: '28px' }}>
                                        <div>📧 {loan.email}</div>
                                        <div>📱 +91 {loan.phone}</div>
                                    </div>
                                </div>

                                <div className="loan-amount-display">
                                    <span className="amount-label">Requested Amount</span>
                                    <span className="amount-value">₹{Number(loan.amount).toLocaleString('en-IN')}</span>
                                </div>

                                <div className="loan-info-grid">
                                    <div className="info-item">
                                        <span className="info-label">Calc. EMI</span>
                                        <span className="info-value">₹{Number(loan.emi).toLocaleString('en-IN')}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="info-label">Applied On</span>
                                        <span className="info-value">{new Date(loan.created_at).toLocaleDateString('en-IN')}</span>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', gap: '0.5rem', marginTop: '1.5rem' }}>
                                    <button
                                        className="btn-pay-emi"
                                        onClick={() => handleUpdateStatus(loan.id, 'Active')}
                                        disabled={actionLoading === loan.id}
                                        style={{ flex: 1, background: '#22c55e', color: 'white' }}
                                    >
                                        {actionLoading === loan.id ? '...' : 'Approve'}
                                    </button>
                                    <button
                                        className="btn-secondary"
                                        onClick={() => handleUpdateStatus(loan.id, 'Rejected')}
                                        disabled={actionLoading === loan.id}
                                        style={{ flex: 1, background: '#ef4444', color: 'white', border: 'none' }}
                                    >
                                        {actionLoading === loan.id ? '...' : 'Reject'}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: '5rem', background: 'rgba(255,255,255,0.02)', borderRadius: '16px', border: '1px dashed rgba(255,255,255,0.1)' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🎉</div>
                        <h3>No Pending Applications</h3>
                        <p style={{ color: '#888' }}>You have cleared all pending loan requests. Good job!</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AdminLoansPage;
